"use strict";

var _slicedToArray = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _require = require("./utils.js"),
    solelyContainsHTTPTokenCodePoints = _require.solelyContainsHTTPTokenCodePoints;

module.exports = function (mimeType) {
  var serialization = "".concat(mimeType.type, "/").concat(mimeType.subtype);

  if (mimeType.parameters.size === 0) {
    return serialization;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = mimeType.parameters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref3 = _step.value;

      var _ref2 = _slicedToArray(_ref3, 2);

      var name = _ref2[0];
      var value = _ref2[1];
      serialization += ";";
      serialization += name;
      serialization += "=";

      if (!solelyContainsHTTPTokenCodePoints(value) || value.length === 0) {
        value = value.replace(/(["\\])/g, "\\$1");
        value = "\"".concat(value, "\"");
      }

      serialization += value;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return serialization;
};